import angular from 'angular';
import * as constants from './constants';

export const PathsConstantsModule = angular.module('buildium.constants.paths', [])
    .constant('BASE_PATH', constants.BASE_PATH)
    .constant('BASE_PATH_API', constants.BASE_PATH_API)
    .constant('BASE_PATH_APP', constants.BASE_PATH_APP)
    .constant('BASE_PATH_PUBLIC', constants.BASE_PATH_PUBLIC)
    .constant('LOGIN_PATH', constants.LOGIN_PATH)
    .constant('FILE_DOWNLOAD_BASE', constants.FILE_DOWNLOAD_BASE)
    .constant('IS_LOCALHOST', constants.IS_LOCALHOST)
    .constant('HYBRID_LOCALHOST', constants.HYBRID_LOCALHOST)
    .constant('PUBLIC_HYBRID_LOCALHOST', constants.PUBLIC_HYBRID_LOCALHOST);

export {
    BASE_PATH,
    BASE_PATH_API,
    BASE_PATH_APP,
    BASE_PATH_PUBLIC,
    LOGIN_PATH,
    FILE_DOWNLOAD_BASE,
    IS_LOCALHOST,
    HYBRID_LOCALHOST,
    PUBLIC_HYBRID_LOCALHOST
} from './constants';
